import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedUserDataService {

  private userDataObj = new BehaviorSubject(null);
  currentMessage = this.userDataObj.asObservable();

  constructor() { }

  async changeMessage(message: any) {
    this.userDataObj.next(message)
  }
}
